



















import { Component, Vue, Prop } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { ProductsApi, Product } from '../api';
import { Validation } from 'vuelidate';
import { VueSelect } from 'vue-select';

@Component({
	components: { VueSelect },
})
export default class ProductPicker extends Vue {
	// computed
	get validationState() {
		if (this.validator) {
			return this.validator.$dirty && this.validator.$invalid;
		}
		return null;
	}

	@Prop(Object)
	public value?: object;

	@Prop(Object)
	public readonly validator?: Validation;

	@Prop(Boolean)
	public readonly disabled?: boolean;

	public options: Product[] = [];
	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
		this.debouncedOptions = debounce(this.fetchOptions, 100);
	}

	public onSelect(item: any) {
		if (this.validator) {
			this.validator.$touch();
		}
		this.$emit('input', item);
	}

	public onSearch(search: string, loading: any) {
		// if (!search || search.length < 3) {
		if (!search) {
			this.debouncedOptions.cancel();
			loading(false);
			return;
		}
		this.debouncedOptions.cancel();
		loading(true);
		this.debouncedOptions(search, loading);
	}

	public async fetchOptions(search: string, loading: any) {
		loading(true);
		const options = {
			params: {
				include: 'subscriptionitem,users',
				'filter[name]': search,
				'fields[products]': 'id,name,type',
			},
		};
		const response = await this.api.getProducts(options);
		this.options = response.data.data || [];
		loading(false);
	}

	private readonly debouncedOptions: any = () => {
		return [];
	};
}
